// const DESIGN_WIDTH = 1136; // value of canvas width, for which the design fits best ( need for aspect ration calculus)

cc.Class({
    extends: cc.Component,

    properties: {
        designWidth: {
            default: 1136,
            type: cc.Integer
        },
        debug: false,
    },

    ctor () {
        this.screenWidth = 0;
        this.scaleRatio = 1;
        this.nodesList = [];
    },

    onLoad () {
        cc.game.addPersistRootNode(this.node);

        this._measure();

        this.onResize = () => this._resizeNodes();
        cc.view.setResizeCallback(this.onResize);
        this._registerResizeHandlers();
    },

    /**
     * Request view resize for a given component
     * @param {ScaleController} component
     */
    requestViewResize (component) {
        this._measure();

        if (component && typeof component.onViewResize === 'function') {
            component.onViewResize(this.scaleRatio, this.aspectRatio);
        }
    },

    _measure () {
        this.screenRect = cc.view.getVisibleSize();
        this.screenWidth = this.screenRect.width;
        this.scaleRatio = this.screenWidth / this.designWidth;
        this.aspectRatio = this.screenRect.width / this.screenRect.height;
        if (this.debug) {
            cc.log("aspect: ", this.aspectRatio,  ", scale: ", this.scaleRatio);
        }
    },

    /**
     * registers resize handler functions. will not register in preview mode
     */
    _registerResizeHandlers () {
        if (CC_PREVIEW) {
            return;
        }

        // window.addEventListener('resize', (evt) => {
        //     this._onResize(evt.detail);
        // });
        // window.addEventListener('fullscreen', (evt) => {
        //     this._onResize(evt.detail);
        //     if (!window.PSGames.CommonAPI.CommonUI.getCurrentCard()) {
        //         cc.director.resume();
        //     }
        // });
        window.addEventListener('fullscreenmask', () => {
            cc.director.pause();
        });

    },

    /**
     * resize handler function
     * @param {object} if needed to explicitly set canvas size on resize
     */
    _onResize (e) {
        if (e) {
            cc.view.setFrameSize(e.width, e.height);
        } else {
            cc.view.setFrameSize(window.innerWidth, window.innerHeight);
        }
        // eslint-disable-next-line no-underscore-dangle
        cc._widgetManager.onResized();
    },

    /** updates Registered nodes */
    _resizeNodes () {
        /**
         * For some reason the widget is not updated when resized in PREVIEW mode, this is a workaround that
         * applies only to PREVIEW mode.
         */
        if (CC_PREVIEW) {
            // eslint-disable-next-line no-underscore-dangle
            cc._widgetManager.onResized();
        }
        this._measure();

        this.nodesList.forEach((node) => {
            node.onViewResize(this.scaleRatio, this.aspectRatio);
        });
    },

    /** adds node to the nodesList. used by the ScaleController */
    appendNode (node) {
        this.nodesList.push(node);
        node.onViewResize(this.scaleRatio, this.aspectRatio);
    },

    /** removes node from view resize update */
    removeNode (node) {
        this.nodesList = this.nodesList.filter((value) => {
            return value !== node;
        });
    }
});
